import React, { useEffect ,useState} from 'react'
import './Newcollection.css'
import Item from '../item/Item'
const Newcollection = () => {

  const [new_collection,setNew_collection] = useState([]);

  useEffect(()=>{
      fetch(`/api/newcollections`)
      .then((response)=>response.json())
      .then((data)=>setNew_collection(data))
      .catch((err)=>console.error("Could not load new collections:", err));
  },[])
  return (
    <div  id='new-collections' className='new-collections'>
      <h1>NEW COLLECTIONS</h1>
      <hr />
      <div className="collections">
        {new_collection.map((item,i)=>{
          return <Item key={i} id={item.id} name={item.name} image={item.image} new_price={item.new_price} old_price={item.old_price} />
        })}
        </div> 
    </div>
  )
}

export default Newcollection
